module.exports = __webpack_public_path__ + "static/media/vector-selected-dark.07712ea7.svg";